import {
    UPDATE_ADD_TO_CART
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ADD_TO_CART:
            return {
                ...state,
                SUBMIT_loading: false,
                product: action.product,
                status:action.status
            }
        default:
            return state
    }
}